<!-- =========================================================================================
  File Name: UserList.vue
  Description: User List page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>


  <div id="page-user-list">


<div class="vx-row">
  <div class="vx-col w-1/3">
  
  <vx-card class="p-2">
    <!-- {{ user }} -->
                    <vs-avatar class="mx-auto mb-6 block" size="80px" :src="user.image" />
                    <div class="text-center">
                        <h4>{{user.name}} {{user.surname}}</h4>
                        <p class="text-grey">{{ user.email }}</p>
                    </div>
                    <div class="flex  ">
                      <vs-button type="gradient" class="w-full mt-6" color="#7367F0" gradient-color-secondary="#CE9FFC"
                      :to="{
                name: 'employee-proflie',
                params: { employeeId: $route.params.estruturaId },
              }"
              
                      >Visualizar
                    
                      </vs-button>
                    </div>
                    <template slot="footer">
                        <vs-divider />
                        <div class="flex justify-between">
                            <span class="flex items-center">
                                <!-- <feather-icon :icon="card_4.footer_text_1_icon" svgClasses="h-5 w-5 text-warning stroke-current" /> -->
                                <span class="ml-2">Estado:</span>
                            </span>
                            <span class="flex items-center">
                                <!-- <feather-icon :icon="card_4.footer_text_2_icon" svgClasses="h-5 w-5 text-primary stroke-current" /> -->
                               <strong> <span v-if="structures.status==1" style="color:green">Activo</span> <span v-if="structures.status==0">Inactivo</span></strong>
                            </span>
                        </div>
                    </template>
                </vx-card>

  </div>
            <div class="vx-col w-2/3">
    <vs-card>
      
    
    <vs-table search stripe :data="components">
     
<template  slot="header">
            <vs-button v-if="canAddEmp || canAddPayroll" @click="popupAdd=true" icon-pack="feather" icon="icon-plus"  color="primary" type="border" class="mb-2">Adicionar componente</vs-button>
         
          </template>
  <template slot="thead">
    <vs-th sort-key="name">Nome</vs-th>
    <vs-th sort-key="name">Abreviatura</vs-th>
    <vs-th sort-key="name">Valor(Mt)</vs-th>

    <!-- <vs-th sort-key="birth_date">Data de Nascimento</vs-th> -->
    <vs-th></vs-th>
    <!-- <vs-th sort-key="id">Nro</vs-th> -->
  </template>

  <template slot-scope="{data}">
    <vs-tr  :key="indextr" v-for="(tr, indextr) in data">
      
<vs-td :data="data[indextr].name">
       
        {{ data[indextr].name }}
      </vs-td>
      <vs-td :data="data[indextr].abbreviation">
       
        {{ data[indextr].abbreviation }}
      </vs-td>
       
      <vs-td :data="data[indextr].amount">
       
        {{ data[indextr].pivot.amount }}
      </vs-td>
    

    <!-- <vs-td>
      <vs-chip >
                        <div class="h-2 w-2 rounded-full mr-1" :class="'bg-danger'"></div>
                    </vs-chip>
    </vs-td> -->
    

    
      <vs-td class="whitespace-no-wrap" :data="data[indextr].id">
        <vs-row>
                    <vs-button :disabled="data[indextr].abbreviation=='INSS' || data[indextr].abbreviation=='IRPS' || !canUpdatePayroll || !canUpdateEmp" color="success" size="small" hover:text-danger type="border" icon-pack="feather" icon="icon-edit"  @click="popupOpenEdit(tr)">

                    </vs-button>
                    
                    <vs-button :disabled="!canDeletePayroll" class="ml-2" color="danger"  type="border" size="small" icon-pack="feather" icon="icon-trash" @click="openConfirm(tr)"></vs-button>
             </vs-row>
              <!-- <feather-icon icon="TrashIcon" svgClasses="w-5 h-5 hover:text-danger stroke-current" class="ml-2" @click.stop="deleteData(tr.id)" /> -->
            </vs-td>

      <!-- <vs-td :data="data[indextr].id">
        {{ data[indextr].id }}
      </vs-td> -->
    </vs-tr>
  </template>
</vs-table>
 <div style="height: 50px;" id="div-with-loading" class="vs-con-loading__container"></div>
</vs-card>
            </div>
            </div>


<vs-popup class="holamundo" title="Actualizar Componente Salarial" :active.sync="popupEdit">
     <div class="vx-row">
       <div class="vx-col w-full mb-2">
      <label class="mt-8" for="">Montante(Mt)</label>
      <vs-input  class="w-full mt-2 mb-5"  type="number" v-model="dado.pivot.amount" />
      </div>
      
 <div class="vx-col w-full mb-2">
<div class="flex flex-wrap items-center flex-start">
      <vs-button class="ml-auto mt-2" @click="editData">Actualizar</vs-button>
      <vs-button class="ml-4 mt-2" type="border" color="warning">Cancelar</vs-button>
</div>
      
    </div>
    </div>
    </vs-popup>

<vs-popup class="holamundo" title="Adicionar Componente Salarial" :active.sync="popupAdd">
<div class="vx-row">
<!-- 
   <div class="vx-col w-full">
          <label class="mt-8" for="">Nome da estrutura</label>
      <vs-input class="w-full mt-2 mb-2"  type="text" v-model="name"   v-validate="'required|alpha_spaces'"
                name="nome"/>
       <span class="text-danger text-sm"  v-show="errors.has('nome')">{{ errors.first('nome') }}</span>
        </div> -->
        
  


       

<div class="vx-col w-full mb-2">
      <div class="form-group" v-for="(input,k) in inputs" :key="k">

      <div class="vx-col w-full">
      
      <label for="">Componente salarial</label>
            <v-select
      name="componente"
              v-validate="'required'"
                v-model="input.component_id"
                
                :reduce="(options) => options.id"
                :options="arrayObj"
              >
              </v-select>
              <span class="text-danger text-sm"  v-show="errors.has('componente')">{{ errors.first('componente') }}</span>
   </div>
     <div class="vx-col w-full">
   <!-- <input type="text" class="form-control" v-model="input.id"> -->
    <label for="" class="mt-5">Valor</label>
     <vs-input class="w-full  mb-2"  type="number" v-model="input.amount" name="valor"  v-validate="'required|numeric'"
                />
                   <span class="text-danger text-sm"  v-show="errors.has('valor')">{{ errors.first('valor') }}</span>
   </div>
   <span>
      <div class="flex flex-wrap items-center flex-start">
      <vs-button  class="ml-auto mt-2" size="small" icon-pack="feather" icon="icon-plus"  @click="add(k)" v-show="k == inputs.length-1"></vs-button>

        <vs-button class="ml-4 mt-2" type="border" color="warning" size="small" icon-pack="feather" icon="icon-trash" @click="remove(k)" v-show="k || ( !k && inputs.length > 1)"></vs-button>
    
    </div>
    </span>
    <vs-divider></vs-divider>
  </div>
  </div>
  <!-- <button @click="addCandidate">
    gravar
  </button> -->

 <div class="vx-col w-full mb-2">
<div class="flex flex-wrap items-center flex-start">
      <vs-button class="ml-auto mt-2" @click="saveData">Salvar</vs-button>
      <vs-button class="ml-4 mt-2" type="border" color="warning">Cancelar</vs-button>
</div>
      
    </div>
    </div>
    </vs-popup>
  </div>

</template>

<script>
import vSelect from 'vue-select'
import http from "../../../../../http-common";
import { PermissionsMixin } from "../../../../mixins/permissions"
// Store Module

// Cell Renderer


export default {
  mixins:[PermissionsMixin],
  components: {
    vSelect,

 
    
  },
  data() {
    return {
      // selected:[],
      user:[],
     inputs: [{
        component_id: [],
        amount: '',
      }],
      popupAdd:false,
      popupEdit:false,
      name:"",
      abbreviation:"",
      type:"",
      structures:[],
      components:[],

      component:[
        {
         id: '',
        amount: '',
        selectedComponent:'',
        }
      ],
componente:[],
employees:[],
currentUser:[],
arrayObj:[],
dado:{
  pivot:{
    amount:"",
    id:""
}
},

    }
  },

  mounted() {
    this.initialize();
  },

 
  methods: {




    initialize(){
      this.getData();
      // this.getCurrentUser();
      this.getComponent();
      // this.getStructure();
    },




/////////////////////////////////////teste

    add () {
      this.inputs.push({
        component_id: '',
        amount: ''
      })
      console.log(this.inputs)
    },

    remove (index) {
      this.inputs.splice(index, 1)
    },

    addCandidate () {
      
      let token = localStorage.getItem("token");
      let config = {
        headers: {
          authorization: "Bearer " + token,
        },
      };
  
      const data = {
          name:'Teste',
          component:JSON.stringify(this.inputs)
          
      };

     http
        .post("/salaries/salary-structures", data, config)
        .then((success) => {
          success;
        this.popupAdd=false,
        
          this.$vs.loading.close();
          this.$vs.notify({
            title: "Sucesso",
            text: "Estrutura salaria adicionado com sucesso!",
            color: "success",
            position: "top-right",
          })
        })
        .catch((error) => {
          error;
          this.err= error.response.data
          this.$vs.loading.close();
          this.$vs.notify({
            title: "Erro",
            text: this.err,
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "danger",
            position: "top-right",
          })
        });

    },
//////////////////////////////////////////



  // getStructure() {
      
  //      this.$vs.loading()
    
  //     let token = localStorage.getItem("token");
  //     let config = {
  //       headers: {
  //         authorization: "Bearer " + token,
  //       },
  //     };
      
  //     http
  //       .get("/salaries/salary-structures", config)
  //       .then((result) => {
  //          this.$vs.loading.close()
  //         this.structures = result.data.SalaryStructure
  //       })
  //       .catch((error) => {
  //         error;
          
  //         if(error.response.status==401 ){
  //           this.$router.push('/').catch(() => {})
  //         }
         
  //       });
  //   },

     getComponent() {
      
    
      let token = localStorage.getItem("token");
      let config = {
        headers: {
          authorization: "Bearer " + token,
        },
      };
      
      http
        .get("/salaries/components", config)
        .then((result) => {
          this.components = result.data.SalaryComponents

        this.arrayObj = this.components.map(item => {
      return {
        id: item.id,
        label: item.name
      };
    });
          this.novo=this.components.map(d =>  d.responsability_name)
// alert("2")
        })
        .catch((error) => {
          error;
          
          if(error.response.status==401 ){
            this.$router.push('/').catch(() => {})
          }
         
        });
    },

    getData() {
      
         this.$vs.loading({
        container: '#div-with-loading',
        scale: 1.0,
        type:'sound'
      })
    
    
      let token = localStorage.getItem("token");
      let config = {
        headers: {
          authorization: "Bearer " + token,
        },
      };
      
      http
        .get(`/salaries/salary-structures/${this.$route.params.estruturaId}`, config)
        .then((result) => {
              this.$vs.loading.close('#div-with-loading > .con-vs-loading')
          this.components = result.data.salary_components
          this.structures = result.data
          this.user = result.data.structure_employee.user
// alert("2")
        })
        .catch((error) => {
          error;
          
          if(error.response.status==401 ){
            this.$router.push('/').catch(() => {})
          }
         
        });
    },

           async saveData() {
            
        //      this.$validator.validateAll().then(result => {
        // if (result) {
          
           this.$vs.loading()


      let token = localStorage.getItem("token");
      let config = {
        headers: {
          authorization: "Bearer " + token,
        },
      };
  
      const data = {
          components:JSON.stringify(this.inputs)
          
      };

     http
        .post(`/salaries/add-components/${this.$route.params.estruturaId}`, data, config)
        .then((success) => {
          success;
        this.popupAdd=false,
        this.inputs= [{
        component_id: [],
        amount: '',
      }],
        this.getData(),
          this.$vs.loading.close();
          this.$vs.notify({
            title: "Sucesso",
            text: "Adicionado com sucesso!",
            color: "success",
            position: "top-right",
          })
        })
        .catch((error) => {
          error;
          this.err= error.response.data
          this.$vs.loading.close();
          this.$vs.notify({
            title: "Erro",
            text: this.err,
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "danger",
            position: "top-right",
          })
        });
        // }})

   
    },


    openConfirm(componente) {
this.componente=componente,
            this.$vs.dialog({
                type: 'confirm',
                color: 'danger',
                title: `Confirmação`,
                text: 'Tem certeza que deseja eliminar?' ,
                accept: this.cancel
            })
        },


          async cancel() {
         
           this.$vs.loading()


      let token = localStorage.getItem("token");
      let config = {
        headers: {
          authorization: "Bearer " + token,
        },
      };
  
      

      this.$validator.validateAll();
     http
        .delete(`/salaries/remove-component-structures/${this.componente.pivot.id}`,config)
        .then((success) => {
          success;
        this.popupEdit=false,
        
        this.getData(),
          this.$vs.loading.close();
          this.$vs.notify({
            title: "Sucesso",
            text: "Removido com sucesso!",
            color: "success",
            position: "top-right",
          })
        })
        .catch((error) => {
          error;
          this.err= error.response.data
          this.$vs.loading.close();
          this.$vs.notify({
            title: "Erro",
            text: this.err,
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "danger",
            position: "top-right",
          })
        });
        // }})

   
    },




 popupOpenEdit(component){
   this.dado=component,
         this.popupEdit=true

          
        },

           async editData() {
        //      this.$validator.validateAll().then(result => {
        // if (result) {
           this.$vs.loading()


      let token = localStorage.getItem("token");
      let config = {
        headers: {
          authorization: "Bearer " + token,
        },
      };
      const data = {
          amount:this.dado.pivot.amount,        
      };

      this.$validator.validateAll();
     http
        .patch(`/salaries/update-components/${this.dado.pivot.id}`, data, config)
        .then((success) => {
          success;
        this.popupEdit=false,
        
        this.getData(),
          this.$vs.loading.close();
          this.$vs.notify({
            title: "Sucesso",
            text: "Actualizado com sucesso!",
            color: "success",
            position: "top-right",
          })
        })
        .catch((error) => {
          error;
          this.err= error.response.data
          this.$vs.loading.close();
          this.$vs.notify({
            title: "Erro",
            text: this.err,
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "danger",
            position: "top-right",
          })
        });
        // }})

   
    },




  
},

}

</script>

